import type { SITE_PILOTS_COUNT_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/site-pilots-count-card/site-pilots-count-card.fr.ts";

export const SITE_PILOTS_COUNT_CARD_ENGLISH_LOCALE = {
  title: "Pilots",
  subtitle: "On site",
  seeMore: "See more",
} satisfies typeof SITE_PILOTS_COUNT_CARD_FRENCH_LOCALE;
